export default __webpack_public_path__ + "static/media/defiance.c730f9eb.png";